
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getRegion",
      resolverType: "query",
      routePath: "/getRegion",
      httpMethod: "POST",
    });
  